import { ReactNode } from "react";
import { UserProfileHeader } from "@/components/common/UserProfileHeader";
import { BottomNavigation } from "@/components/layout/BottomNavigation";

interface MobileLayoutProps {
  children: ReactNode;
  currentTab: string;
  onTabChange: (tab: string) => void;
  onTransactionSuccess: () => void;
}

export function MobileLayout({ 
  children, 
  currentTab, 
  onTabChange, 
  onTransactionSuccess 
}: MobileLayoutProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-background to-muted/20 flex flex-col">
      {currentTab === 'dashboard' && <UserProfileHeader />}
      <main className={`flex-1 overflow-auto pb-20 ${currentTab === 'dashboard' ? 'pt-20' : 'pt-4'}`}>
        {children}
      </main>
      <BottomNavigation 
        currentTab={currentTab}
        onTabChange={onTabChange}
        onTransactionSuccess={onTransactionSuccess}
      />
    </div>
  );
}